module.exports = __webpack_public_path__ + "static/img/13.70e21a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/13.png
// module id = at36
// module chunks = 0